import type {
  SearchV2SuggestionsEndpointResponseData,
  SearchEntity,
  ProductSearchSuggestion,
  CategorySearchSuggestion,
  NavigationItemSuggestion,
} from '@scayle/storefront-nuxt'

const useSearchSuggestions = (
  data: Ref<SearchV2SuggestionsEndpointResponseData | undefined>,
) => {
  const allSuggestions = computed(() => {
    return [...(data?.value?.suggestions ?? [])].filter((a) => a)
  })

  const isProduct = (
    suggestion?: SearchEntity,
  ): suggestion is ProductSearchSuggestion => {
    return suggestion?.type === 'product'
  }

  const isCategory = (
    suggestion?: SearchEntity,
  ): suggestion is CategorySearchSuggestion => {
    return suggestion?.type === 'category'
  }

  const isNavigation = (
    suggestion?: SearchEntity,
  ): suggestion is NavigationItemSuggestion => {
    return suggestion?.type === 'navigationItem'
  }

  const products = computed(() => allSuggestions.value.filter(isProduct))
  const categories = computed(() => allSuggestions.value.filter(isCategory))
  const navigationItems = computed(() =>
    allSuggestions.value.filter(isNavigation),
  )
  const totalCount = computed(
    () => products.value.length + categories.value.length,
  )

  return {
    products,
    categories,
    navigationItems,
    noSuggestions: computed(() => totalCount.value === 0),
    totalCount,
  }
}

export default useSearchSuggestions
